<div class="report-container" >
  
  <div  >
    
  </div>
  
  <!-- Individual Buttons -->
  <div class="button-container">
    <button class="nav-link report-button" *ngFor="let item of utility.reports" (click)="onReportSelectionChange(item.reportId)">{{item.name}}</button>
    <button class="bi bi-printer print" (click)="printReport()"></button>
    <!-- <a class="back" >
      <img src="../../../../../assets/newimg/arrow-1-3@2x.png" class="back" (click)="onBack()" style="cursor: pointer; margin: 10px;" />
    </a> -->

  </div>
<div class="" id="reportcontainer">
  <powerbi-report
  #powerbiReport
    [embedConfig]="reportConfig"
    [cssClassName]="reportClass"
    [phasedEmbedding]="phasedEmbeddingFlag"
    [eventHandlers]="eventHandlersMap"
    
  >
  </powerbi-report>
</div>
  <div *ngIf="!isEmbedded" class="display-message">
    <label>{{ displayMessage }}</label>
  </div>
</div>
